import {Injectable} from '@angular/core';
import {deserialize, JsonApiParams, JsonApiResponse} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaAuthHttpService} from '../tisa-auth-http.service';
import {HttpContext, HttpHeaders} from '@angular/common/http';
import {UmpireClientConfig} from '@tisa-group/models';
import {RETURN_FULL_RESPONSE} from '@tisa-group/core/utils';

@Injectable()
export class ConfigService {
  constructor(readonly http: TisaAuthHttpService) {}

  getClientConfig(
    params?: JsonApiParams,
    token?: string,
  ): Observable<JsonApiResponse<UmpireClientConfig>> {
    const tisaToken = token ?? localStorage.getItem('TISA_TOKEN') ?? '';

    const headers = new HttpHeaders({
      authorization: tisaToken,
    });

    return this.http
      .get('/settings/configurations', {
        headers,
        params,
        context: new HttpContext().set(RETURN_FULL_RESPONSE, true),
      })
      .pipe(deserialize());
  }
}
